import { render, staticRenderFns } from "./independent-study-card.vue?vue&type=template&id=4f4b6ff5&scoped=true&"
import script from "./independent-study-card.ts?vue&type=script&lang=ts&"
export * from "./independent-study-card.ts?vue&type=script&lang=ts&"
import style0 from "./independent-study-card.scss?vue&type=style&index=0&id=4f4b6ff5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4b6ff5",
  null
  
)

export default component.exports